import { FC } from 'react';

export type TIcon = () => JSX.Element;

export enum EIconColorType {
    fill = 'fill',
    stroke = 'stroke',
}

export enum MenuSelectBoxType {
    renGpt = 'renGpt',
}

export type TSideNavMenu = {
    icon?: TIcon | FC;
    iconColorType?: EIconColorType;
    title?: string;
    route?: string;
    launchDarklyFlag?: string;
    isCommandCenter?: boolean;
    isBilling?: boolean;
    showOpenInNewTab?: boolean;
    workspaceSettingFlag?: string;
    /**
     * Treat an unset workspaceSettingFlag as enabled, matching the backend convention where only
     * an explicit false disables. Use for capabilities added after accounts were created, whose
     * settings rows do not carry the key yet.
     */
    selectBoxType?: MenuSelectBoxType;
    items?: TSideNavMenu[];
};
